import { z } from "zod";

export const emailSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
});

export type EmailModel = z.infer<typeof emailSchema>;

export const phoneSchema = z.object({
  mobile_number: z
    .string()
    .regex(/^\d+$/, { message: "Mobile number must be a number" })
    .min(1, { message: "Mobile number is required" })
    .min(10, { message: "Mobile number must be 10 digits" })
    .max(10, { message: "Mobile number must be 10 digits" }),
});

export type PhoneModel = z.infer<typeof phoneSchema>;
